import classNames from "classnames/bind";
import { ColourOption } from "@/components/Colours/types.ts";
import { Swatches } from "@/components/Colours/ColourList/Swatches/Swatches.tsx";
import { Picker } from "@/components/Colours/ColourList/Picker/Picker.tsx";
import { isDiorBrand } from "@JohnLewisPartnership/jl-design-system/dist/utils/brands/brands";
import { useStandardProps } from "@/context/StandardPropsContext/StandardPropsContext";
import { productIsInCategory } from "@/utils/category/productIsInCategory";
import { BEAUTY_DEFAULT_CATEGORY_IDS } from "@/utils/category/categoryIds";
import styles from "./ColourList.module.scss";

const cx = classNames.bind(styles);

type Props = {
  /**
   * An array of colour option objects.
   */
  colourOptions: ColourOption[];
  /**
   * A string which represents the product brand name.
   */
  brand?: string;
  /**
   * A boolean toggling history push with replace
   */
  replaceHistoryEntryOnVariantChange: boolean;
};

export const ColourList = ({
  brand,
  colourOptions,
  replaceHistoryEntryOnVariantChange,
}: Props) => {
  const { product } = useStandardProps();
  const selectedColourIndex = colourOptions.findIndex((c) => c.selected);
  const selectedColourOption = colourOptions[selectedColourIndex];
  const isBeautyCategory = productIsInCategory(
    product,
    BEAUTY_DEFAULT_CATEGORY_IDS,
  );

  if (!selectedColourOption || !selectedColourOption) {
    return null;
  }

  const isDior = isDiorBrand(brand);

  return (
    <div className={cx("wrapper")}>
      <h4 data-testid="colourlist:label" className={cx("selectedColour")}>
        <span>Colour: </span>
        <span className={cx("title")}>{selectedColourOption?.colour}</span>
      </h4>
      {isBeautyCategory && colourOptions.length > 8 && (
        <Picker
          selectedColourOption={selectedColourOption}
          colourOptions={colourOptions}
          replaceHistoryEntryOnVariantChange={
            replaceHistoryEntryOnVariantChange
          }
        />
      )}
      <Swatches
        colourOptions={colourOptions}
        isDior={isDior}
        selectedColourIndex={selectedColourIndex}
        replaceHistoryEntryOnVariantChange={replaceHistoryEntryOnVariantChange}
        isBeautyCategory={isBeautyCategory}
      />
    </div>
  );
};
